/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { SliderPicker } from 'react-color'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import useInputValue from '../../../utils/hooks/useInputValue'
import { Buttons, useStyles, Centered } from './styles'

export default function ZoneEditModal({
  init,
  open,
  handleClose,
  onSubmitEdit,
}) {
  const [color, setColor] = useState(init.color.props.style.color)
  const [idzone] = useState(init.id)
  const classes = useStyles()
  const zona = useInputValue(init.name)

  const handlerSubmit = (event) => {
    event.preventDefault()
    onSubmitEdit({
      color,
      zona: zona.value,
      idzone,
    })
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Edite la zona seleccionada
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <form
                className={classes.root}
                noValidate
                autoComplete="off"
                onSubmit={handlerSubmit}
              >
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <Centered>
                      <TextField
                        style={{ textAlign: 'center' }}
                        className={classes.text}
                        required
                        id="standard-required"
                        label="Nombre de la zona"
                        {...zona}
                      />
                      <br />
                    </Centered>
                  </Grid>
                  <Grid item sm={12}>
                    <Centered>
                      <Buttons variant="contained" type="onSubmit">
                        Guardar
                      </Buttons>
                    </Centered>
                  </Grid>
                </Grid>
              </form>
            </Grid>
            {/*  */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.pos} color="textSecondary">
                Seleccione un nuevo color
              </Typography>
              <div>
                <SliderPicker
                  color={color}
                  onChangeComplete={(color) => {
                    setColor(color.hex)
                  }}
                />
                <div
                  style={{
                    backgroundColor: color,
                    height: '5rem',
                    width: '100%',
                  }}
                >
                  {color}
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
